<div class="header">
    <h2>{{ 'courses.modules.dialog.title' | translate }}</h2>
    <div class="header-actions">
        <a pButton [outlined]="true" size="small" data-test="dialog-select-module-create" routerLink="create">
            <i class="pi pi-plus" pButtonIcon></i>
            <span pButtonLabel>{{ 'courses.modules.dialog.createNew' | translate }}</span>
        </a>
        <button class="close" type="button" [attr.aria-label]="'common.close' | translate" data-test="dialog-select-module-close" (click)="close()">
            <i class="pi pi-times"></i>
        </button>
    </div>
</div>

<div class="body">
    <app-dialog-search [placeholder]="searchPlaceholder" testId="dialog-select-module-search" (searchChange)="onSearch($event)" />

    <div class="list-container">
        @if (loading()) {
            <div class="list-loading"><i class="pi pi-spin pi-spinner"></i></div>
        }
        @if (items().length === 0 && !loading()) {
            <p class="empty">{{ 'courses.modules.dialog.empty' | translate }}</p>
        } @else {
            <div class="list">
                @for (item of items(); track item.id) {
                    <button class="item" [attr.data-test]="'dialog-select-module-item-' + item.id" (click)="selectModule(item)">
                        <div class="icon">
                            <i class="pi pi-th-large"></i>
                        </div>
                        <div class="details">
                            <span class="name">{{ item.name }}</span>
                            @if (item.description) {
                                <span class="description">{{ item.description }}</span>
                            }
                        </div>
                        <span class="count">{{ item.items.length }}</span>
                    </button>
                }
            </div>
        }
    </div>
    <p-paginator [rows]="limit" [totalRecords]="total()" [first]="first()" (onPageChange)="onPageChange($event)" />
</div>
